import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { notifyWalkMe } from '@/utils/walkme/notifyWalkMe';

export const useWalkMeRouteSync = (): void => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    notifyWalkMe();
  }, [pathname, search]);
};
